import { useEffect, useState } from "react";
import api, { apiErr, fmtMoney } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export function SubmitValidationDialog({ open, onOpenChange, ops, onDone }) {
  const [op, setOp] = useState("");
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [pick, setPick] = useState(null);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!op) { setList([]); return; }
    const t = setTimeout(() => api.get("/validations/sources", { params: { op_type: op, q } }).then((r) => setList(r.data)).catch((e) => toast.error(apiErr(e))), 250);
    return () => clearTimeout(t);
  }, [op, q]);
  const go = async () => {
    setBusy(true);
    try { const r = await api.post("/validations/submit", { op_type: op, source_id: pick.id, comment }); toast.success(`Demande ${r.data.numero} soumise`); onOpenChange(false); onDone(r.data.id); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="val-submit-dialog">
        <DialogHeader><DialogTitle className="font-head">Soumettre une opération à validation</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">Type d'opération</Label>
            <Select value={op} onValueChange={(v) => { setOp(v); setPick(null); }}><SelectTrigger className="mt-1" data-testid="val-submit-op"><SelectValue placeholder="Choisir" /></SelectTrigger>
              <SelectContent>{ops.map((o) => <SelectItem key={o.key} value={o.key}>{o.label} ({o.module})</SelectItem>)}</SelectContent></Select></div>
          {op && <Input placeholder="Rechercher par numéro ou nom" value={q} onChange={(e) => setQ(e.target.value)} data-testid="val-submit-search" />}
          {op && <div className="max-h-56 overflow-y-auto rounded-lg border divide-y" data-testid="val-submit-sources">
            {list.length === 0 ? <p className="p-3 text-sm text-slate-400">Aucune opération disponible.</p> : list.map((s) => (
              <button type="button" key={s.id} onClick={() => setPick(s)} className={`w-full text-left p-2 text-sm hover:bg-slate-50 ${pick?.id === s.id ? "bg-brand-50" : ""}`} data-testid={`val-source-${s.id}`}>
                <span className="font-mono text-xs text-brand-700 mr-2">{s.ref}</span>{s.objet}
                <span className="float-right text-xs text-slate-500">{s.montant != null ? fmtMoney(s.montant) : ""} {s.validation && `· ${s.validation}`}</span>
              </button>
            ))}
          </div>}
          <div><Label className="text-xs">Commentaire (facultatif)</Label><Textarea rows={2} value={comment} onChange={(e) => setComment(e.target.value)} className="mt-1" data-testid="val-submit-comment" /></div>
          <Button disabled={!pick || busy} onClick={go} className="w-full bg-brand-600 hover:bg-brand-700 text-white" data-testid="val-submit-confirm">{busy ? "Soumission…" : "Soumettre"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
